import { t } from "i18next";
export const LessonActivityDeliveredNote = (props) => {
  const { slidePosition } = props;

  return (
    <div
      className={`slideNote slideNote${slidePosition} summaryNote`}
      id="summaryNote"
      data-position={slidePosition}
    >
      <div className="slideNoteWrapper">
        <div className="slideNoteContent d-flex align-items-center">
          <div className="container">
            <div className="d-flex justify-content-center mb-1">
              <h1 className="text-primary fw-bold">{t("congratulations")}</h1>
            </div>
            <div className="d-flex justify-content-center mb-4">
              <h3>{t("succ.sent.activity.teacher")}</h3>
            </div>
            <div className="d-flex justify-content-center mb-4">
              <p className="text-muted">{t("remember.corrected.activity")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
